import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";

import { Event, EventTracker } from "../../../tracking/service/EventTracker/EventTrackerService";
import { useProgressPercentEffect } from "../Common/hooks/useProgressPercentEffect";
import { useRegistrationContext } from "../Common/registrationContext";
import { useRegistrationLocationForm } from "../Common/registrationState";
import { REGISTRATION_PROGRESS_PERCENT, useIsEntity } from "../Common/service";
import { RegistrationPageContainer } from "../RegistrationPageContainer/RegistrationPageContainer";

import { RegistrationLocationForm } from "./RegistrationLocationForm";
import { FormProvider } from "./RegistrationLocationFormContext";
import { useSave, validate } from "./service";

const RegistrationLocation = () => {
  const registrationLocationForm = useRegistrationLocationForm();
  const { save } = useSave();
  useProgressPercentEffect(REGISTRATION_PROGRESS_PERCENT.Location);
  const { isVet } = useIsEntity();
  const {
    registrationContext: { entityId },
  } = useRegistrationContext();

  useEffect(() => {
    EventTracker.send({
      eventName: isVet ? Event.Name.VET_VIEW_ZIP : Event.Name.TECH_VIEW_ZIP,
      eventType: Event.Type.CLICK,
      entityType: isVet ? Event.Entity.VET : Event.Entity.TECH,
      entityId: entityId,
    });

    EventTracker.send({
      eventName: Event.Name.COMPLETE_REGISTRATION,
      eventType: Event.Type.IMPRESSION,
      entityType: isVet ? Event.Entity.VET : Event.Entity.TECH,
      entityId: entityId,
    });

    EventTracker.send({
      eventName: isVet ? Event.Name.VET_SIGNUP_COMPLETE : Event.Name.TECH_SIGNUP_COMPLETE,
      eventType: Event.Type.IMPRESSION,
      entityType: isVet ? Event.Entity.VET : Event.Entity.TECH,
      entityId: entityId,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <RegistrationPageContainer>
      <FormProvider defaultForm={registrationLocationForm} save={save} validate={validate}>
        <RegistrationLocationForm />
      </FormProvider>
    </RegistrationPageContainer>
  );
};

// eslint-disable-next-line no-restricted-exports
export default withRouter(RegistrationLocation);
